import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'
import { UpdateModal } from './UpdateModal.component'

const withUnmountHoc = withUnmountTransition(UpdateModal)
export { withUnmountHoc as UpdateModal }
